/**
 * Copyright 2025 Google LLC. This software is provided as-is, without warranty 
 * or representation for any use or purpose. Your use of it is subject to your 
 * agreement with Google.
 */
import { Component, inject } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogRef,
  MatDialog,
} from '@angular/material/dialog';
import { PreviewCitationComponent } from '../preview-citation/preview-citation.component';

@Component({
  selector: 'app-preview-panel-dialog',
  standalone: true,
  imports: [PreviewCitationComponent],
  templateUrl: './preview-panel-dialog.component.html',
  styleUrl: './preview-panel-dialog.component.scss'
})

export class PreviewPanelDialogComponent {
  constructor(private dialog: MatDialog) { }
  dialogData = inject(MAT_DIALOG_DATA);
  closePreview: boolean = false;
  readonly dialogRef = inject(MatDialogRef<PreviewPanelDialogComponent>);

  closePreviewSection(isClose: boolean) {
    this.closePreview = isClose;
    this.dialogRef.close();
    this.dialog.closeAll();
  }

}
